import { createSlice } from '@reduxjs/toolkit'

export const authTokenSlice = createSlice({
    name: 'authToken',
    initialState: {
      value: {}
    },
    reducers: {
      clear: (state) => {
        // Redux Toolkit allows us to write "mutating" logic in reducers. It
        // doesn't actually mutate the state because it uses the Immer library,
        // which detects changes to a "draft state" and produces a brand new
        // immutable state based off those changes.
        // Also, no return statement is required from these functions.
        state.value = {}
      },
      set: (state, action) => {
        state.value = action.payload
      },
    },
  })
  
  // Action creators are generated for each case reducer function
  export const { clear, set } = authTokenSlice.actions
  
  export default authTokenSlice.reducer